export default __webpack_public_path__ + "static/media/Sliderimg03.3ff55cb2.jpg";